import moment from 'moment';
import React, { useState } from 'react'
import { errorAlert } from '../../../../../Static_Services/Alertmsg';
import Swal from 'sweetalert2';
import { waiver_customer_family } from '../../../../../Studio-Services/Studio_Services';

export default function FamilyMember({ selectMemberId, cmProfile, getCustomerCloverCard,
    viewFamilyPass, setChild_ID,
    resetFamilyPass, update, newFamilyAdd, familyWaiver
}) {




    return (
        <>
            {selectMemberId == 0 &&
                <div className="row" >
                    <div className="col-8">
                        <h4 className="title text-capitalize mt-5">Family Members</h4>
                    </div>
                    <div className="col-4 text-right">
                        <button className="btn btn-brandblue mt-5 mr-3 text-right" data-toggle="modal" data-target="#addFamily" onClick={() => newFamilyAdd()}
                            data-backdrop="static" data-keyboard="false">Add Family Members</button>
                    </div>
                </div>
            }
            <div className="row family-section">
                {(cmProfile.family_member || []).map((fam) => (
                    <div className="col-xl-4">
                        <div className="right-productdetail-sec p-4 relative mt-5 customer-section">
                            <div className="row mx-0 align-items-center">
                                <div className="col-md-3">
                                    <div className="user-profile-img">
                                        <img src={fam.image} className="img-fluid" alt='profile image' />
                                    </div>
                                </div>
                                <div className="col-md-9">
                                    <div className="selected-user-detail pl-3">
                                        <span style={{ display: 'flex' }}>
                                            <h5 className="text-capitilize mb-1">
                                                {fam.member_name}
                                            </h5>
                                            {selectMemberId == 0 &&
                                                <button className="d-inline-block border-radius6 ml-2 mr-2"
                                                    onClick={() => update(fam)}>
                                                    <a href="Javascript:void(0);">
                                                        <i className="fas fa-pencil-alt"></i>
                                                    </a>
                                                </button>
                                            }
                                        </span>

                                        <span className="brand-light">Relation: {fam.relation}</span>
                                        <p className="mb-0">DOB: {moment(fam.dob).format(' MMMM DD, YYYY')}</p>
                                        <p className="mt-1 mb-0">Gender: {fam.gender}</p>

                                        {fam.waiver === 0 ?
                                            <p className="mt-1 mb-0">Waiver:
                                                <input className="ml-2" style={{ cursor: "pointer" }} type="checkbox"
                                                    onClick={(e) => familyWaiver(fam.id, fam.member_name, e, cmProfile.email)}
                                                />
                                            </p>
                                            :
                                            <p className="mt-1 mb-0">Waiver:
                                                <input className="ml-2" type="checkbox" style={{ cursor: "pointer" }} checked={true} readOnly />
                                            </p>
                                        }
                                        {selectMemberId == 0 ?
                                            <div >
                                                <a className="mt-1 mb-0 pass-edit-view btn btn-brandbluegrad"
                                                    onClick={() => {
                                                        viewFamilyPass(fam.id);
                                                        setChild_ID(fam.id);
                                                    }}
                                                >View Details</a>
                                            </div>
                                            :
                                            <div >
                                                {fam.id == selectMemberId &&
                                                    <a className="mt-1 mb-0 pass-edit-view  btn btn-brandgreengrad"
                                                        onClick={() => {
                                                            resetFamilyPass();
                                                            getCustomerCloverCard();
                                                            setChild_ID('');
                                                        }}>Back</a>}
                                            </div>
                                        }

                                        <button type="button" data-toggle="modal" data-target="#addFamily" id="btn_close"
                                            className="btn text-capitalize w-100 mt-3" data-backdrop="static" data-keyboard="false"
                                            style={{ display: "none" }}> </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </>

    )
}
